export default __webpack_public_path__ + "static/media/logo-lune.6d8310d1.png";